export enum EOfferType {
	cpa = 'cpa',
	spend = 'spend',
}